import React, { useState } from "react";
import { useTheme } from "../hooks/useTheme";
import Logo from "../assets/images/preload.png";
import { useUser } from "../context/UserContext";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { IconMoon, IconLogout, IconSunFilled, IconHome, IconTax, IconTransfer } from "@tabler/icons-react";

import ModalLogout from "../components/ModalLogout";

const SidebarPage = () => {
  const { theme, setTheme } = useTheme();
  const { userData } = useUser();
  const navigate = useNavigate();
  const [mostrarModal, setMostrarModal] = useState(false);

  const toggleTheme = () => setTheme(theme === "light" ? "dark" : "light");

  const location = useLocation();

  // Verifica si alguna de las subrutas está activa
  const isActiveDropdown = location.pathname.includes("/admin/AdminClientes") || location.pathname.includes("/admin/AdminTarifas");

  return (
    <aside className="navbar navbar-vertical navbar-expand-lg" data-bs-theme={theme}>
      <div className="container-fluid d-flex flex-column h-100">
        <div className="navbar-brand navbar-brand-autodark">
          <div className="d-flex align-items-center">
            <img src={Logo} width={"40px"} alt="" />
            <span className="font-ecotrans text-verde" style={{ fontSize: "30px" }}>
              Eco
            </span>
            <span className={`font-ecotrans ${theme === "light" ? "text-negro" : "text-white"}`} style={{ fontSize: "30px" }}>
              trans
            </span>
          </div>
        </div>

        {/* Menú de navegación */}
        <div className="collapse navbar-collapse show">
          <ul className="navbar-nav pt-lg-3">
            <li className={`nav-item ${location.pathname === "/admin/AdminHome" ? "active" : ""}`}>
              <Link to="/admin/AdminHome" className="nav-link">
                <span className="nav-link-icon">
                  <IconHome size={20} />
                </span>
                <span className="nav-link-title">Home</span>
              </Link>
            </li>

            <li className={`nav-item dropdown ${isActiveDropdown ? "active" : ""}`}>
              <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" data-bs-auto-close="false" role="button" aria-expanded="false">
                <span className="nav-link-icon">
                  <IconTax size={20} />
                </span>
                <span className="nav-link-title">Parámetros</span>
              </a>
              <div className="dropdown-menu">
                <Link to="./AdminClientes" className="dropdown-item">
                  Clientes
                </Link>
              </div>
            </li>
          </ul>
        </div>

        {/* Botón cerrar sesión abajo */}
        <div className="mt-auto pt-3 border-top text-center">
          <div className="container btn-list my-1">
            <a href="../panel/Home" className="btn btn-secondary w-100" target="_self" rel="noreferrer">
              <IconTransfer size={20} className="me-2" />
              Cambiar Panel
            </a>
            <button onClick={() => setMostrarModal(true)} className="btn btn-danger w-100">
              <IconLogout size={20} />
              <span className="ms-2">Cerrar sesión</span>
            </button>
          </div>

          <ModalLogout visible={mostrarModal} onClose={() => setMostrarModal(false)} />
        </div>
      </div>
      <button
        className={`btn ${theme === "light" ? "btn-outline-dark" : "btn-outline-light"}`}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          borderRadius: "50%",
          width: "56px",
          height: "56px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        aria-label="Botón flotante"
        onClick={toggleTheme}
      >
        {theme === "light" ? (
          <>
            <IconMoon size={32} />
          </>
        ) : (
          <>
            <IconSunFilled size={32} />
          </>
        )}
      </button>
    </aside>
  );
};

export default SidebarPage;
